import React from "react";
import { Spinner } from "../../components";

const Callback = () => {
  return <Spinner message={"Logging in"} />;
};

export default Callback;



// WEBPACK FOOTER //
// ./src/views/callback/Callback.jsx